import { gameBoyModes, type GameBoyMode } from "./components/modeSwitch";

export type EspLoadState = "idle" | "loading" | "ready" | "error";

export function modeForRomHeader(
    rom: Uint8Array,
    filename: string,
    currentMode: GameBoyMode,
): GameBoyMode {
    if (rom.length > 0x143) {
        const cgbFlag = rom[0x143];
        if (cgbFlag === 0xc0) return gameBoyModes.cgb;
        if (cgbFlag === 0x80) return currentMode;
        return gameBoyModes.dmg;
    }
    return filename.toLowerCase().endsWith(".gbc")
        ? gameBoyModes.cgb
        : currentMode;
}

export function canStartRom(
    isDaydream: boolean,
    espLoadState: EspLoadState,
): boolean {
    return !isDaydream || espLoadState === "ready";
}
